import { LoaderFunctionArgs, useLoaderData } from "react-router";
import { AuditLogRepresentation } from "../infrastructure/api/api";
import { organizationContext } from "../infrastructure/organization/OrganizationContext";
import { auditLogApi } from "./auditLogApi";

interface AuditLogRouteData {
  entries: AuditLogRepresentation[];
}

export const auditLogLoader = async ({
  context,
}: LoaderFunctionArgs): Promise<AuditLogRouteData> => {
  const organization = context.get(organizationContext);

  return { entries: await auditLogApi(organization).getPage(0) };
};

export const useInitialAuditLog = (): AuditLogRepresentation[] =>
  useLoaderData<AuditLogRouteData>().entries;
